import lodashUtil from 'lodash'
import format from 'date-fns/format';
import theme from '../../../../assests/theme'
import {getDayForHourAndMin} from '../weeklyCalendar/WeeklyCalendarUtil'
const anHour = 60;
const blocketUnit = anHour/24;
const minimumBreakBlocketCount = 6;

let timeTableSlots7 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots1 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots2 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots3 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots4 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots5 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})
let timeTableSlots6 =Array.apply(null, new Array(24)).map(function(el, i) {return {"timeBlock":i++ }})  
let outputDummyArray = [
  {
    "day": "Mon",
    "dayNumber": 1,
    "timeSlots": [...timeTableSlots1]
  },
  {
    "day": "Tue",
    "dayNumber": 2,
    "timeSlots": [...timeTableSlots2]
  },
  {
    "day": "Wed",
    "dayNumber": 3,
    "timeSlots": [...timeTableSlots3]
  },
  {
    "day": "Thu",
    "dayNumber": 4,
    "timeSlots": [...timeTableSlots4]
  },
  {
    "day": "Fri",
    "dayNumber": 5,
    "timeSlots": [...timeTableSlots5]
  },
  {
    "day": "Sat",
    "dayNumber": 6,
    "timeSlots": [...timeTableSlots6]
  },
 {
    "day": "Sun",
     "dayNumber": 0,
     "timeSlots": [...timeTableSlots7]
  }
]
// let outputDummyArray = [
//   {
//     "day": "MONDAY",
//     "dayNumber": 1,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },
//   {
//     "day": "TUESDAY",
//     "dayNumber": 2,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },
//   {
//     "day": "WEDNESDAY",
//     "dayNumber": 3,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },
//   {
//     "day": "THURSDAY",
//     "dayNumber": 4,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },
//   {
//     "day": "FRIDAY",
//     "dayNumber": 5,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },
//   {
//     "day": "SATURDAY",
//     "dayNumber": 6,
//     "timeSlots": [

//       {
//         "timeBlock": 6
//       }, {
//         "timeBlock": 7
//       }, {
//         "timeBlock": 8
//       },
//       {
//         "timeBlock": 9
//       },
//       {
//         "timeBlock": 10
//       },
//       {
//         "timeBlock": 11
//       },
//       {
//         "timeBlock": 12
//       },
//       {
//         "timeBlock": 13
//       },
//       {
//         "timeBlock": 14
//       },
//       {
//         "timeBlock": 15
//       },
//       {
//         "timeBlock": 16
//       }, {
//         "timeBlock": 17
//       }, {
//         "timeBlock": 18
//       }, {
//         "timeBlock": 19
//       }

//     ]
//   },

// ]
export const getTimeTableSlotsForTeacher = (days, header) => {
  let outputArray=[]
  let tempArray = JSON.parse(JSON.stringify(outputDummyArray));

  days.map(function (dayObj) {
    let dayIndex=tempArray.findIndex((day)=>day.dayNumber==dayObj.dayNumber)
    if(dayIndex>=0){
      outputArray.push(tempArray[dayIndex])
    let dayheader = header.find((day) => day.dayNumber == dayObj.dayNumber);
    if (dayheader != undefined) {
      let filteredPeriods = dayheader.periods.filter((period) => (period.typeOfPeriod == 'lunch' || period.typeOfPeriod == 'break'))

      filteredPeriods.map(function (period) {
        outputArray = createBlock(outputArray, period, dayObj.dayNumber, undefined);
      })
    }
    dayObj.classes.map(function (class1) {
      if (class1.subject != undefined) {
      
        outputArray = createBlockForTeacher(outputArray, class1, dayObj.dayNumber);
      }
    })
  }
  })
  return outputArray
}
export const getTimeTableSlotsForAvailableTeacher = (days) => {

  let outputArray=[]
  let tempArray = JSON.parse(JSON.stringify(outputDummyArray));
  let i = 0;
  let color = ''
  days.map(function (dayObj) {
    let dayIndex=tempArray.findIndex((day)=>day.dayNumber==dayObj.dayNumber)
    if(dayIndex>=0){
      outputArray.push(tempArray[dayIndex])
  
    dayObj.periods.map(function (period) {
      if (period.typeOfPeriod != 'lunch' && period.typeOfPeriod != 'break') {
        if (i >= theme.colorCatalogue.length) {
          color = theme.colorCatalogue[i % theme.colorCatalogue.length]

        }
        else {
          color = theme.colorCatalogue[i]
        }
        i++
      }
      outputArray = createBlockForAvailableTeacher(outputArray, period, dayObj.dayNumber, color);

    })
  }
  })
  return outputArray
}

export const getTimeTableSlots = (class1) => {
  let outputArray=[]
  let tempArray = JSON.parse(JSON.stringify(outputDummyArray));
  class1.days.map(function (dayObj) {
    let dayIndex=tempArray.findIndex((day)=>day.dayNumber==dayObj.dayNumber)
    if(dayIndex>=0 ){
      outputArray.push(tempArray[dayIndex])
  
    let periods = dayObj.periods.filter((period => period.subject != undefined && period.subject.code != undefined))
    let breaksPeriods = dayObj.periods.filter((period => (period.typeOfPeriod == 'lunch' || period.typeOfPeriod == 'break')))
    breaksPeriods.map(function (period, periodIndex) {
      outputArray = createBlock(outputArray, period, dayObj.dayNumber, undefined);
    })
    periods.map(function (period, periodIndex) {
      outputArray = createBlock(outputArray, period, dayObj.dayNumber);
    })
  }
  })

  return outputArray;
}

const createBlockForTeacher = (outputArray, class1, day,period) => {

  let startDateObject = getDayForHourAndMin(class1.startTime_str);
  let endDateObject = getDayForHourAndMin(class1.endTime_str);
  let startHour = startDateObject.getHours()
  let startMinutes = startDateObject.getMinutes();
  //let endMinutes = endDateObject.getMinutes();
  // if (startHour == 0) {
  //   startHour = 12
  // }

  let outputArrayDayIndex = lodashUtil.findIndex(outputArray, { 'dayNumber': day });
  let dayTimeSlotIndex = lodashUtil.findIndex(outputArray[outputArrayDayIndex].timeSlots, { 'timeBlock': startHour });
  let blocketConfig = {};
  // blocketConfig.startingBlocket = (startMinutes / 5) + 1;
  // blocketConfig.totalBlocks = ((class1.endTime - class1.startTime) / (1000 * 60 * 5));
  

  blocketConfig.startingBlocket = (startMinutes / blocketUnit)+1 ;
  var minutes = Math.floor((class1.endTime -  class1.startTime) / 60000);
  blocketConfig.totalBlocks = ((minutes) /  blocketUnit);

  blocketConfig.label = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')} `

  if (class1 != undefined) {
    blocketConfig.period = class1;
    blocketConfig.style = class1.color
    blocketConfig.subject = class1.subject;
    blocketConfig.class1 = class1;
  }
  if (outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration != undefined && outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.length > 0) {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);
  } else {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration = [];
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);

  }
  return outputArray;
}

const createBlock = (outputArray, period, day) => {
 ////change for string
  let startDateObject = getDayForHourAndMin(period.startTime_str);
  let endDateObject = getDayForHourAndMin(period.endTime_str);
  let startHour = startDateObject.getHours()
  let startMinutes = startDateObject.getMinutes();
  // if (startHour == 0) {
  //   startHour = 12
  // }

  let outputArrayDayIndex = lodashUtil.findIndex(outputArray, { 'dayNumber': day });

  let dayTimeSlotIndex = lodashUtil.findIndex(outputArray[outputArrayDayIndex].timeSlots, { 'timeBlock': startHour });
  let blocketConfig = {};
  // blocketConfig.startingBlocket = (startMinutes / 5) + 1;
  // blocketConfig.totalBlocks = ((period.endTime - period.startTime) / (1000 * 60 * 5));
  blocketConfig.startingBlocket = (startMinutes / blocketUnit)+1 ;
  blocketConfig.totalBlocks = (period.duration /  blocketUnit);
  blocketConfig.period = period;

  if (period.subject != undefined) {
    blocketConfig.label = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')}`

    blocketConfig.style = period.subject.color
    blocketConfig.subject = period.subject.name;
    blocketConfig.teachers = period.subject.teachers;
    if (period.subject.rooms != undefined) {
      blocketConfig.rooms = period.subject.rooms;
    }
    if (period.className != undefined) {
      blocketConfig.className = period.className;
    }
  }
  if (outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration != undefined && outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.length > 0) {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);
  } else {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration = [];
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);

  }
  return outputArray;
}


const createBlockForAvailableTeacher = (outputArray, period, day, color) => {
  let startDateObject = getDayForHourAndMin(period.startTime_str);
  let endDateObject = getDayForHourAndMin(period.endTime_str);
  let startHour = startDateObject.getHours()
  let startMinutes = startDateObject.getMinutes();
  // if (startHour == 0) {
  //   startHour = 12
  // }

  let outputArrayDayIndex = lodashUtil.findIndex(outputArray, { 'dayNumber': Number(day) });

  let dayTimeSlotIndex = lodashUtil.findIndex(outputArray[outputArrayDayIndex].timeSlots, { 'timeBlock': startHour });
  let blocketConfig = {};
  // blocketConfig.startingBlocket = (startMinutes / 5) + 1;
  // blocketConfig.totalBlocks = ((period.endTime - period.startTime) / (1000 * 60 * 5));
  blocketConfig.startingBlocket = (startMinutes / blocketUnit)+1 ;
  blocketConfig.totalBlocks = ((period.duration)  /  blocketUnit);
  blocketConfig.style = color
  blocketConfig.label = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')} `
  blocketConfig.period = period;
  blocketConfig.availableTeachersList = period.availableTeachersList

  if (outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration != undefined && outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.length > 0) {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);
  } else {
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration = [];
    outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);

  }
  return outputArray;
}
